var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145 28.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#FEFEFE",
    strokeWidth: 2,
    strokeLinecap: "round",
    d: "M1.7,1.1h141.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M37.7,1.8c20,0,22.5,0.7,22.5,14c0,7.2,4.6,12.1,11.8,12.1S83.8,23,83.8,15.8c0-13.3,2.8-13.9,22.5-13.9 C106.2,1.9,37.7,1.8,37.7,1.8z M72,23.7c-5.9,0-10.5-4.8-10.5-10.5c0-5.9,4.8-10.5,10.5-10.5s10.5,4.8,10.5,10.5S77.9,23.7,72,23.7z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FEFEFE",
    d: "M70,19.2c0-0.2,0-0.7,0-1.3c-2.1,0.5-2.6-1-2.6-1c-0.4-0.9-0.8-1.2-0.8-1.2c-0.7-0.5,0-0.5,0-0.5 c0.8,0,1.2,0.8,1.2,0.8c0.7,1.2,1.8,0.8,2.2,0.7c0.1-0.5,0.3-0.8,0.5-1c-1.7-0.1-3.4-0.8-3.4-3.8c0-0.8,0.3-1.6,0.8-2.1 c-0.1-0.1-0.4-0.9,0.1-2c0,0,0.7-0.3,2.1,0.8c0.7-0.1,1.3-0.3,2-0.3c0.7,0,1.3,0.1,2,0.3c1.4-1,2.1-0.8,2.1-0.8c0.4,1,0.1,1.8,0.1,2 c0.5,0.5,0.8,1.2,0.8,2.1c0,2.9-1.8,3.5-3.5,3.8c0.3,0.3,0.5,0.7,0.5,1.4c0,1,0,1.8,0,2.1c0,0.3,0.1,0.4,0.5,0.4h-5.1 C69.5,19.4,70,19.4,70,19.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.d8a1dedb6ea843d59d221e800fe166ed.svg";
export { ForwardRef as ReactComponent };